<section class="section" style="min-height: calc(100dvh - 3.25rem)">
  <img
    src="https://static.porozmawiaj.my/pm-patient/themes/default/assets/b1.webp"
    alt="Hero"
    class="hero-image"
    fetchpriority="high"
    width="100%"
    height="100%"
    style="min-height: 100vh"
  />
  <div class="section-content">
    <main class="section-main">
      <div class="section-content-container">
        <text-header i18n>Porozmawiajmy kończy się na My</text-header>
      </div>
      <colorful-button
        i18n-label
        label="zaplanuj swoją wizytę"
        (buttonClick)="onPlanVisit()"
        class="mb-4"
      />
    </main>
  </div>
</section>
